import * as amplitude from '@amplitude/analytics-browser'
import { Box, Grid } from '@material-ui/core'
import classNames from 'classnames'
import { useContext } from 'react'
import { useIntl } from 'react-intl'
import { useQueryClient } from 'react-query'
import { ReactComponent as GoogleLogo } from 'src/assets/icons/google.svg'
import img from 'src/assets/images/calendar-wifi.png'
import { Modal, Typography } from 'src/modules/core/components'
import { AuthContext } from 'src/modules/user/context'
import { redirectToGoogleAuth } from 'src/modules/user/redirectToGoogleAuth'
import { getPendingConnectedAppAuthorizePath } from 'src/modules/user/requirements/pending-connected-app.storage'
import { TokenService } from 'src/services/token.service'
import classes from './sync-offline-changes-modal.module.scss'

interface SyncOfflineChangesModalProps {
  isBookingUser?: boolean
}

export function SyncOfflineChangesModal({ isBookingUser = false }: SyncOfflineChangesModalProps) {
  const { formatMessage } = useIntl()
  const { logoutUser, setIsReauthorizingForOfflineSync } = useContext(AuthContext)

  const queryClient = useQueryClient()

  const handleButtonClick = () => {
    amplitude.track('Onboarding_ContinueWithGoogle_button')
    if (isBookingUser) {
      amplitude.track('Booking_onboarding_Sync_Calendars_Complete')
    }

    setIsReauthorizingForOfflineSync(true)
    const pendingConnectedAppPath = getPendingConnectedAppAuthorizePath()
    if (pendingConnectedAppPath) {
      sessionStorage.setItem('postLoginRedirectPath', pendingConnectedAppPath)
    }
    // Set flag to redirect to settings after login (only for booking users)
    if (isBookingUser) {
      sessionStorage.setItem('redirectToBookingSettings', 'true')
    }
    logoutUser()
    TokenService.getInstance().removeToken()
    queryClient.removeQueries()
    redirectToGoogleAuth(true)
  }

  return (
    <Modal className={classNames(classes.modal, 'translate')}>
      <Grid container direction="row" justifyContent="center" alignItems="center" spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h3" className={classes.modalTitle}>
            {formatMessage({ id: 'onboarding.syncOfflineChanges.title' })}
          </Typography>
        </Grid>
        <Grid item>
          <p>
            {formatMessage({
              id: isBookingUser
                ? 'onboarding.syncOfflineChanges.bookingText1'
                : 'onboarding.syncOfflineChanges.smsText1',
            })}
          </p>
        </Grid>
        <Grid item>
          <p>
            {formatMessage({
              id: isBookingUser
                ? 'onboarding.syncOfflineChanges.bookingText2'
                : 'onboarding.syncOfflineChanges.smsText2',
            })}
          </p>
        </Grid>
        <Grid item>
          <img src={img} alt="Calendar icon with wifi signal" aria-hidden="true" className={classes.image} />
        </Grid>
        <Grid item>
          <button onClick={handleButtonClick} className={classes.continueWithGoogle}>
            <Box display="flex" alignItems="center" justifyContent="center">
              <GoogleLogo className={classes.googleLogo} />
              <span>{formatMessage({ id: 'onboarding.syncOfflineChanges.button' })}</span>
            </Box>
          </button>
        </Grid>
      </Grid>
    </Modal>
  )
}
